//
//

import { uid } from "quasar";
import { FabricDiagram } from "../../../assets/js/Diagram/diagram/fabric-diagram";
import { StandardData } from "../../../assets/js/Diagram/data/standard";
import { GridView } from "../../../assets/js/Diagram/views/grid/grid-view";
import { DEFAULT_PLUGINS } from "../const/DefaultPlugins";
import { DIAGRAM_EMIT_EVENTS } from "../../../assets/js/Diagram/diagram/modules/DiagramEvents";

export default {
    name: "DiagramWrapper",
    props: {
        value: Object,
        config: Object,
        plugins: Array,
        zoomBtsPosition: [Number, String]
    },
    data() {
        return {
            diagramInstance: null,
            canvasRef: null,
            diagramReadonly: null,
            instanceUuid: uid()
        };
    },
    computed: {
        setZoomBtnPosition() {
            let zoomPosition = "";
            if (this.zoomBtsPosition) {
                if (typeof this.zoomBtsPosition === "string" && this.zoomBtsPosition.includes("%")) {
                    zoomPosition = `bottom:${this.zoomBtsPosition}; left:24px`;
                } else {
                    zoomPosition = `bottom:${this.zoomBtsPosition}px; left:24px`;
                }
            }

            return zoomPosition;
        },
        getDiagramZoomlevel() {
            return this.diagramInstance
                ? this.diagramInstance.getZoomLevel() * 100
                : 0;
        },
        getCanvasContainerID() {
            return `canvasContainer-${this.instanceUuid}`;
        },
        getCanvasID() {
            return `canvas-${this.instanceUuid}`;
        }
    },
    created() {
        this.diagramInstance = new FabricDiagram(this.instanceUuid);
        this.setInstanceToWindow();
    },
    activated() {
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 0);
    },
    mounted() {
        this.initializeDiagram();
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 0);
        this.setInstanceToWindow();
    },
    destroyed() {
        delete window.diagramInstances[this.instanceUuid];
        this.diagramInstance.destroyDiagram(this.instanceUuid);
    },
    methods: {
        resizeDiagramContainer() {
            this.diagramInstance.eventHandlerInstance.onWindowResize();
        },
        zoomIn() {
            this.diagramInstance.zoomIn();
        },
        zoomOut() {
            this.diagramInstance.zoomOut();
        },
        resetZoom() {
            const zoomLevel = this.diagramInstance.getZoomLevel();
            if (zoomLevel !== 1) {
                const zoomDiff = parseFloat((1 - zoomLevel).toFixed(1));
                this.diagramInstance.resetZoom(zoomDiff);
            }
        },
        eventEmitted($event) {
            if (!this.diagramReadonly) {
                this.$emit("FABRIC_DIAGRAM_EVENT", $event.detail);
                // console.log(
                //   "INSIDE DIAGRAM WRAPER. EVENT TRIGGERED. EVENT DATA:",
                //   $event
                // );
                const eventType = $event.detail.type;
                if (this.value && this.isModelChangeEvent(eventType)) {
                    const self = this;
                    setTimeout(() => {
                        const diagramData = self.diagramInstance.getDiagramData();
                        self.$emit("input", diagramData);
                    }, 30);
                }
            }
        },
        isModelChangeEvent(event) {
            const events = DIAGRAM_EMIT_EVENTS;
            return (
                event === events.PLUGIN_DELETED
        || event === events.PLUGIN_CREATED
        || event === events.CONNECTOR_DELETED
        || event === events.CONNECTOR_CREATED
        || event === events.PLUGIN_LABEL_CREATED
        || event === events.PLUGIN_LABEL_UPDATED
        || event === events.CONNECTOR_LABEL_CREATED
        || event === events.CONNECTOR_LABEL_UPDATED
        || event === events.MULTIPLE_ACTIONS_HAPPENED
        || event === events.CELL_INDEPENDENT_CONTAINER_ADDED
        || event === events.CELL_INDEPENDENT_CONTAINER_REMOVED
        || event === events.CONTAINER_CHILD_REMOVED
        || event === events.CONTAINER_CHILD_ADDED
        || event === events.DIAGRAM_VIEW_INITIALIZED
        || event === events.DIAGRAM_STATE_MODIFICATIONS
            );
        },
        /**
     * @description Returns the JSON of the diagram
     *
     * */
        getDiagramData() {
            return this.diagramInstance.getDiagramData();
        },
        /**
     * @description Returns undo cache length
     */
        getHistoryUndoCacheLength() {
            return this.diagramInstance.getHistoryUndoCacheLength();
        },
        /**
     * @description Returns redo cache length
     */
        getHistoryRedoCacheLength() {
            return this.diagramInstance.getHistoryRedoCacheLength();
        },
        /**
     * @description Performs undo on diagram instance state
     */
        undoState(emitEvents) {
            this.diagramInstance.undoState(emitEvents);
        },
        /**
     * @description Performs redo on diagram instance state
     */
        redoState(emitEvents) {
            this.diagramInstance.redoState(emitEvents);
        },
        /**
     *
     * @param {String} fromUUID
     * @param {String} toUUID
     * @description Provide the UUID of the from and to plugins and it will create a connection between the two
     * @returns {String} NewConnector UUID
     *
     * */
        addConnector(fromUUID, toUUID) {
            return this.diagramInstance.addConnector(fromUUID, toUUID);
        },
        /**
     * @param {String} connectorUUID
     * @description Deletes a connector with the provided UUID
     */
        deleteConnector(connectorUUID) {
            this.diagramInstance.deleteConnector(connectorUUID);
        },
        updateConnectorLabel(connectorUUID, label) {
            this.diagramInstance.updateConnectorLabel(connectorUUID, label);
        },
        resetDiagramScroll() {
            this.diagramInstance.resetDiagramScroll();
        },
        /**
     * @param {String} anchoredTo - Uuid of the plugin that the element is anchored to
     * @param {String} pluginID - The ID of the plugin that must be created as anchored element. Possible value: "ANCHORED_HEXAGON"
     * @param {AnchorType} anchorType - The type of the plugin that the element is anchored to. Possbile value: "CELL_BASED"
     * @param {position} position - Default Value: TOP_LEFT // Possible Values:
     *                              "TOP_LEFT", "BOTTOM_LEFT", "CENTER_LEFT",
     *                              "TOP_CENTER", "CENTER_CENTER", "BOTTOM_CENTER",
     *                              "TOP_RIGHT", "CENTER_RIGHT", "BOTTOM_RIGHT",
     * @param {offset} offset - Object of type: {x:numericValue, y: numericValue}.
     *                         Positive values will move the element to the right, or bottom of the initial position
     * @param {Object} data - Object of type: {text:'5', fillStyle: desiredColor} that will be set inside the anchored element.
     */
        addPluginAnchoredElement(
            anchoredTo,
            pluginID,
            anchorType,
            position,
            offset,
            data
        ) {
            const uuid = this.diagramInstance.addPluginAnchoredElement(
                anchoredTo,
                pluginID,
                anchorType,
                position,
                offset,
                data
            );
            return uuid;
        },
        /**
     * @param {String} pluginUuid - The anchored plugin UUID to be updated
     * @param {String} anchorPluginUuid  - The uuid of the plugin that the anchored plugin is anchored to
     * @param {Object} options - An object with the properties: {position, offset, data}
     * @description Update plugin with the uuid "pluginUuid" anchored to the element with uuid "anchorPluginUuid"
     */
        updateAnchoredPlugin(pluginUuid, anchorPluginUuid, options) {
            this.diagramInstance.updatePluginAnchoredElement({
                pluginUuid,
                anchorPluginUuid,
                options
            });
        },
        /**
     * @param {String} options.pluginUuid - The plugin UUID to be updated
     * @param {Object} options.updateData - An object with the properties to update plugin design
     * @description Update plugin design with the uuid "pluginUuid"
     */
        updatePluginDesign(options) {
            this.diagramInstance.updatePluginDesign(options);
        },
        /**
     * @param {Object} state - the state to be used for updating the plugin
     * @param {Boolean} isCellIndependent - indicates if is a cell independent plugin or the child of a cell indepenent plugin
     * @description Updates the state of the given pluginUuid with the provided state
     */
        updatePluginState(state, pluginUuid, isCellIndependent, isConnector) {
            this.diagramInstance.updatePluginState(
                state,
                pluginUuid,
                isCellIndependent,
                isConnector
            );
        },
        /**
     * @param {string} pluginID -A string representing the ID of the plugin. Ex: DATA_MODEL
     * @param {object} layout - A object containing the properties: {width,height,x,y}.
     *                          If width,height is not provided the default is used, if x,y is not provided a place on the board is searched.
     *                          If no place is found, a error event is emited.
     * @param {object} state - A object containing the properties: {selected}. If selected is provided and is true, the plugin will be selected upon creation
     * @param {object} data - A object containing the properties: {label(string), children(objectArray)}. If label is not provided, the default will be used
     * @description Create a cell independent container on the board
     */
        addCellIndependentContainer(pluginID, layout, state, data) {
            this.diagramInstance.addCellIndependentContainer(
                pluginID,
                layout,
                state,
                data
            );
        },
        /**
     * @param {string} containerUuid - The uuid of the container
     * @param {string} childPluginID - The plugin ID to be used for child creation. Ex - DATA_MODEL_PROPERTY
     * @param {object} state - A object containing the properties: {selected}. If selected is provided and is true, the plugin will be selected upon creation
     * @param {object} data - A object containing the properties: {label(string)}. If label is not provided, the default will be used
     * @description Creates a child inside a container based on the provided params
     *
     */
        addCellIndependentContainerChild(
            containerUuid,
            childPluginID,
            state,
            data
        ) {
            return this.diagramInstance.addCellIndependentContainerChild(
                containerUuid,
                childPluginID,
                state,
                data
            );
        },
        /**
     * @param {string} containerUuid - The uuid of the container
     * @param {object} data - A object containing the properties: {label(string)}.
     * @description Updates the data of a cell independent container
     *
     */
        updateCellIndependentContainer(containerUuid, data) {
            this.diagramInstance.updateCellIndependentContainer(containerUuid, data);
        },
        /**
     * @param {string} containerUuid - The uuid of the container
     * @param {string} childPluginUUID - The uuid of the child
     * @param {object} data - A object containing the properties: {label(string)}.
     * @description Updates the label of a child inside a cell independent container
     *
     */
        updateCellIndependentContainerChild(containerUuid, childPluginUUID, data) {
            this.diagramInstance.updateCellIndependentContainerChild(
                containerUuid,
                childPluginUUID,
                data
            );
        },
        /**
     * @param {string} containerUuid - The uuid of the container
     * @param {string} childPluginUUID - The uuid of the child
     * @description Removes a child plugin from a cell independent container
     *
     */
        removeCellIndependentContainerChild(containerUuid, childPluginUUID) {
            this.diagramInstance.removeCellIndependentContainerChild(
                containerUuid,
                childPluginUUID
            );
        },
        /**
     * @param {string} containerUuid - The uuid of the container
     * @description Removes a cell independent container
     */
        removeCellIndependentContainer(containerUuid) {
            this.diagramInstance.removeCellIndependentContainer(containerUuid);
        },
        updatePluginLabel(pluginUuid, label, noEvent) {
            this.diagramInstance.updatePluginLabel(pluginUuid, label, noEvent);
        },
        /**
     * @param {String} uuid
     * @description Deletes the plugin with the provided UUID and any related connectors
     */
        deletePlugin(uuid) {
            this.diagramInstance.deletePlugin(uuid);
        },
        /**
     *  @param {Object} dataSet
     *  @description Clears the diagram and loads a new diagram based on the JSON
     */
        changeDataSet(dataSet, isDataModel) {
            const data = this.diagramInstance.changeDataSet(dataSet, isDataModel);
            this.$emit("input", data);
        },

        removeAllCellIndependentPlugins() {
            this.diagramInstance.removeAllCellIndependentPlugins();
        },
        /**
     * @param {Plugin[]} An array of objects with the form of: {id:"TASK_PLUGIN", plugin: TaskPlugin} (where TaskPlugin is the plugin class)
     * @description Registers for use plugins in the diagram
     *
     */
        registerPlugins(plugins) {
            this.diagramInstance.registerPlugin(plugins);
        },
        /**
     * @param {string} connectorUuid
     * @description Selects a connector with the provided uuid
     */
        selectConnector(connectorUuid, customEmitEvent) {
            this.diagramInstance.selectConnector(connectorUuid, customEmitEvent);
        },
        /**
     * @param {string} pluginUuid
     * @param {Boolean} triggerEvent - trigger event - PLUGIN_SELECTED
     * @description Selects a connector with the provided uuid
     */
        selectPlugin(pluginUuid, isCellIndependent, triggerEvent) {
            this.diagramInstance.selectPlugin(pluginUuid, isCellIndependent, triggerEvent);
        },
        /**
     * @param {Boolean} val
     * @param {Boolean} oneAtATime - make diagram readonly when another user is editing it
     * @description Marks the UI as readonly or not.
     */
        setReadonly(val, oneAtATime, enableClick) {
            this.diagramReadonly = enableClick ? !enableClick : val;
            this.diagramInstance.setReadonly(val, oneAtATime);
        },
        initializeDiagram(counter) {
            this.canvasRef = document.querySelector(`#canvas-${this.instanceUuid}`);

            if (!this.canvasRef && (!counter || (counter && counter < 1000))) {
                setTimeout(() => {
                    counter = counter ? counter + 50 : 50;
                    this.initializeDiagram(counter);
                }, 50);
                return;
            } if (!this.canvasRef && counter && counter >= 1000) {
                // console.error(
                //     "Its been over a second since diagramwrapper was initialized and canvas cant be found for diagram initialization"
                // );
                return;
            }
            // if (counter) {
            //     console.warn(
            //         `Diagram was initialized after ${counter} extra miliseconds`
            //     );
            // }
            const data = {}; // DIAGRAM_DATA;
            if (this.diagramInstance) {
                this.diagramInstance = null;
                // this.diagramInstance = getDiagramInstance(this.instanceUuid);
                this.diagramInstance = new FabricDiagram(this.instanceUuid);
            }
            // window.diagramInstance = this;
            this.diagramInstance.init(this.canvasRef, data, {
                containerID: `canvasContainer-${this.instanceUuid}`, // this.getCanvasContainerID(),
                plugins: this.plugins || DEFAULT_PLUGINS,
                view: GridView(),
                dataHandler: StandardData(),
                ...this.config
            });
            const diagramData = this.diagramInstance.getDiagramData();
            this.$emit("input", diagramData);
        },
        setInstanceToWindow() {
            if (!window.diagramInstances) {
                window.diagramInstances = {};
            }
            if (!window.diagramInstances[this.instanceUuid]) {
                window.diagramInstances[this.instanceUuid] = this.diagramInstance;
            }
        }
    }
};
